// extracted by mini-css-extract-plugin
export default {"cookieBanner":"eXImxdvw5d1sydjLe00T","header":"ozkHadX_CPIJanM5xfrs","body":"tj8NWietqEEyTGPlCVmw","manageButton":"NFEKnwgp9TRfmZzg3anb"};